module.exports = __webpack_public_path__ + "img/stop-square.ddede79a.svg";